"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CameraSwitchFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CameraSwitchFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.619v7.095A2.286 2.286 0 0 0 2.286 15h11.428A2.286 2.286 0 0 0 16 12.714V5.62a2.286 2.286 0 0 0-2.286-2.286h-1.188c-.334 0-.651-.145-.868-.399l-.974-1.136A2.286 2.286 0 0 0 8.95 1H7.05c-.667 0-1.3.292-1.735.798l-.974 1.136c-.217.254-.534.4-.868.4H2.286A2.286 2.286 0 0 0 0 5.618Zm6.11 1.05A3.001 3.001 0 0 1 10.83 8h-.863a.25.25 0 0 0-.208.39l1.533 2.299a.25.25 0 0 0 .416 0l1.533-2.3A.25.25 0 0 0 13.033 8h-1.159a4.002 4.002 0 0 0-6.52-2c-.208.183-.186.502.021.685.207.183.52.159.735-.015ZM4.126 10H2.967a.25.25 0 0 1-.208-.389l1.533-2.299a.25.25 0 0 1 .416 0l1.533 2.3a.25.25 0 0 1-.208.388h-.862a3.001 3.001 0 0 0 4.719 1.33c.214-.174.528-.198.735-.015.207.183.229.502.022.684a4.002 4.002 0 0 1-6.52-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CameraSwitchFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = CameraSwitchFill;
exports["default"] = _default;